<template>
  <div id="app" class="news-page">
    <headerView :seletedindex="seletedindex" />

    <!-- 顶部横幅 -->
    <div class="banner">
      <img
        :src="newsInformationBanner.imgUrl"
        alt
        srcset
        class="banner-image"
        draggable="false"
      />
    </div>

    <!-- 新闻列表 -->
    <div class="news">
      <!-- 分类筛选 -->
      <div class="news-header">
        <h2 class="news-header-title">新闻资讯</h2>
        <p class="news-header-desc">聚焦行业前沿，分享企业最新动态</p>
      </div>

      <div class="news_section">
        <span
          v-for="(item, newTypeindex) in newType"
          :key="newTypeindex"
          :class="item.id == active ? 'isactive' : ''"
          @click="selectType(item.id)"
          >{{ item.title }}</span
        >
      </div>

      <!-- 新闻卡片网格 -->
      <div class="newsdetails">
        <div class="news_div" v-if="newsList.length > 0">
          <div
            class="news_div_main"
            v-for="(item, index) in newsList"
            :key="index"
            @click="viewDetails(item.id, item.linkUrl, index)"
          >
            <div class="news_div_img-wrap">
              <img
                :src="item.imgUrl"
                alt
                srcset
                class="news_div_img"
                draggable="false"
              />
              <span class="news_div_tag">{{ item.tag || '新闻' }}</span>
            </div>
            <div class="news_div_body">
              <p class="news_div_p1">
                <span>{{ item.title }}</span>
              </p>
              <p class="news_div_p2" v-if="item.subTitle">{{ item.subTitle }}</p>
              <p class="news_div_p3">
                <span class="news_div_span1">
                  <i class="el-icon-time"></i>
                  <span>{{ item.addTime }}</span>
                </span>
                <span class="news_div_span2">
                  <i class="el-icon-view"></i>
                  <span>{{ item.click }}</span>
                </span>
              </p>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="news-empty" v-else>
          <i class="el-icon-document"></i>
          <p>暂无相关新闻</p>
        </div>
      </div>

      <!-- 分页 -->
      <el-pagination
        v-if="total > 0"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="pageindex"
        @current-change="handleCurrentChange"
        class="pagination"
      ></el-pagination>
    </div>

    <footerView></footerView>
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import {
  homeBanner,
  Getnews,
  getNewsType,
  changeBrowsingFrequency,
} from "@/api/index";
import { timeformat } from "@/utils/timeformat";

export default {
  components: { headerView, footerView },
  data() {
    return {
      seletedindex: 4,
      newType: [],
      active: 0,
      total: 0,
      pageindex: 1,
      pageSize: 9,
      typeid: "",
      newsInformationBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      newsList: [],
    };
  },
  created() {
    this.$nextTick(async () => {
      await this.getnewsInformationBanner();
      await this.getType();
      const categoryId = this.$route.query.categoryId;
      if (categoryId) {
        const categoryIdNum = parseInt(categoryId);
        if (!isNaN(categoryIdNum)) {
          const categoryExists = this.newType.some(
            (type) => type.id === categoryIdNum
          );
          if (categoryExists) {
            this.active = categoryIdNum;
            this.typeid = categoryIdNum;
          }
        }
      }
      await this.getNewsList();
    });
  },
  methods: {
    handleCurrentChange(index) {
      this.pageindex = index;
      this.getNewsList();
    },
    async getType() {
      const typenews = await getNewsType("/api/zaoying/newsCategories");
      if (typenews.length > 0) {
        this.newType = [{ id: 0, title: "全部" }, ...typenews];
      }
    },
    async getNewsList() {
      const news = await Getnews("/api/zaoying/news", {
        category_id: this.typeid,
        pageNumber: this.pageindex,
        pageSize: this.pageSize,
      });
      if (news && news.items.length > 0) {
        this.total = news.totalRecords;
        this.newsList = news.items.map((item) => {
          return {
            id: item.id,
            title: item.title,
            imgUrl: item.imgUrl,
            subTitle: item.subTitle,
            addTime: timeformat(item.addTime),
            click: item.click,
            tag: item.tag || "新闻",
            userName: item.userName,
            linkUrl: item.linkUrl,
          };
        });
      } else {
        this.newsList = [];
      }
    },
    async getnewsInformationBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 10 });
      if (res.length > 0) {
        this.newsInformationBanner = res[0];
      }
    },
    async selectType(index) {
      // 记录当前滚动位置，避免切换分类后页面跳到顶部
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      this.active = index;
      this.pageindex = 1;
      if (index == 0) {
        this.typeid = "";
        this.$router.replace({
          name: "newsInformation",
        });
      } else {
        this.typeid = index;
        this.$router.replace({
          name: "newsInformation",
          query: {
            categoryId: index,
          },
        });
      }
      await this.getNewsList();
      // 数据更新、DOM 重新渲染后，恢复滚动位置
      this.$nextTick(() => {
        window.scrollTo({ top: scrollTop, left: 0, behavior: "instant" });
      });
    },
    async viewDetails(id, url, index) {
      const res = await changeBrowsingFrequency("api/zaoying/browse", { id: id });
      if (this.newsList[index]) {
        this.newsList[index].click += 1;
      }
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: id,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.news-page {
  background-color: #f7f8fc;
  min-height: 100vh;
}

/* ============ Banner ============ */
.banner {
  position: relative;
  width: 100%;
  height: 25vw;
  min-height: 240px;
  max-height: 460px;
  overflow: hidden;
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%);
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ============ 主体内容 ============ */
.news {
  width: 86%;
  max-width: 1280px;
  margin: 80px auto 80px;
}

.news-header {
  text-align: center;
  margin-bottom: 36px;
}

.news-header-title {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
  letter-spacing: 2px;
  position: relative;
  display: inline-block;
}

.news-header-title::before,
.news-header-title::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #409eff);
}

.news-header-title::before {
  right: calc(100% + 18px);
}

.news-header-title::after {
  left: calc(100% + 18px);
  background: linear-gradient(90deg, #409eff, transparent);
}

.news-header-desc {
  font-size: 15px;
  color: #6b7280;
  letter-spacing: 1px;
}

/* ============ 分类筛选 ============ */
.news_section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 50px;
}

.news_section span {
  padding: 10px 26px;
  border-radius: 30px;
  border: 1px solid #e5e7eb;
  background-color: #fff;
  color: #4b5563;
  cursor: pointer;
  user-select: none;
  font-size: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.news_section span:hover {
  color: #2563eb;
  border-color: #93c5fd;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
}

.news_section span.isactive {
  color: #fff;
  border: 1px solid #2563eb;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.35);
  transform: translateY(-2px);
}

/* ============ 新闻卡片网格 ============ */
.newsdetails {
  width: 100%;
}

.news_div {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.news_div_main {
  background-color: #fff;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  border: 1px solid #f0f2f5;
}

.news_div_main:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(37, 99, 235, 0.18);
  border-color: #dbeafe;
}

/* 图片区域 */
.news_div_img-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background-color: #eef2f7;
}

.news_div_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.news_div_main:hover .news_div_img {
  transform: scale(1.08);
}

.news_div_tag {
  position: absolute;
  top: 14px;
  left: 14px;
  padding: 4px 12px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  font-size: 12px;
  letter-spacing: 1px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

/* 卡片正文 */
.news_div_body {
  padding: 22px 22px 18px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.news_div_p1 {
  text-align: left;
  margin-bottom: 10px;
}

.news_div_p1 span {
  display: block;
  font-weight: 600;
  font-size: 17px;
  color: #1f2937;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease;
  min-height: 51px;
}

.news_div_main:hover .news_div_p1 span {
  color: #2563eb;
}

.news_div_p2 {
  text-align: left;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 44px;
}

.news_div_p3 {
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px dashed #eef2f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #9ca3af;
  font-size: 13px;
}

.news_div_span1,
.news_div_span2 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.news_div_span1 i,
.news_div_span2 i {
  font-size: 14px;
  color: #9ca3af;
}

.news_div_span2 i {
  color: #2563eb;
}

/* ============ 空状态 ============ */
.news-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #9ca3af;
}

.news-empty i {
  font-size: 60px;
  color: #d1d5db;
  margin-bottom: 14px;
}

.news-empty p {
  font-size: 15px;
}

/* ============ 分页 ============ */
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.pagination >>> .el-pager li,
.pagination >>> .btn-prev,
.pagination >>> .btn-next {
  border-radius: 8px;
  transition: all 0.25s ease;
}

.pagination >>> .el-pager li.active {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: #fff !important;
}

/* ============ 响应式 ============ */
@media (max-width: 1024px) {
  .news_div {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .news {
    width: 92%;
    margin: 50px auto 60px;
  }

  .news_div {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .banner {
    height: 50vw;
    min-height: 200px;
  }

  .news-header-title {
    font-size: 26px;
  }

  .news_section span {
    padding: 8px 18px;
    font-size: 14px;
  }
}
</style>